/* eslint-disable */
import type { CurrencyCode } from "../../../../common/currency_codes.pb";
import type { ActivityScope, ActivityToken } from "./coremodels.pb";
import type { ActivityRow, RequestContext } from "./models.pb";

export interface ActivitySearchRequest {
  /** Searches the note field on Document as free text. */
  free_text_search?: string;
  filters?: SearchFilter[];
  search_offset?: SearchOffset;
  page_size?: number;
  /** Used to determine the routing key and customer / group of the document */
  activity_token?: ActivityToken;
  sort?: SearchSort;
}

export interface ActivitySearchResponse {
  activity_rows?: ActivityRow[];
  search_offset?: SearchOffset;
}

export interface SearchFilter {
  counterparty?: SearchFilterCounterparty | undefined;
  amount?: SearchFilterAmount | undefined;
  date?: SearchFilterDate | undefined;
}

export interface SearchFilterCounterparty {
  counterparty_token?: string;
}

/** Must use at least one amount filter attribute below. */
export interface SearchFilterAmount {
  /** In USD, this is cents. Inclusive. If null, no gte filter will be applied. */
  amount_gte_in_base_unit?: number;
  /** In USD, this is cents. Inclusive. If null, no lte filter will be applied. */
  amount_lte_in_base_unit?: number;
  /**
   * If null, it will return results for all currencies. There is no default set.
   * Use USD if searching for BTC. BTC Amounts are in USD at the time of the transaction.
   */
  currency?: CurrencyCode;
}

/** Must use at least one date filter attribute below. */
export interface SearchFilterDate {
  /** In epoch millis. Inclusive. If null, no gte filter will be applied. */
  date_gte_in_epoch_millis?: number;
  /** In epoch millis. Inclusive. If null, no lte filter will be applied. */
  date_lte_in_epoch_millis?: number;
}

export interface SearchSort {
  /** Defaults to DATE. */
  sort_by_field?: SearchSortSortByField;
  /** Defaults to DESC. */
  order?: SearchSortOrder;
}

export enum SearchSortSortByField {
  DATE = "DATE",
  AMOUNT = "AMOUNT",
}

export enum SearchSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ActivitySearchPageRequest {
  request?: ActivitySearchRequest;
  activity_scope?: ActivityScope;
}

export interface ActivitySearchPageInternalRequest {
  request?: ActivitySearchRequest;
  activity_scope?: ActivityScope;
  /** Customer token requesting activity search. Will be used with Elasticsearch routing. */
  caller_customer_token?: string;
  /** On the public api, data in request context would be fetched from headers */
  requestContext?: RequestContext;
  /** Indicates whether the incoming request is coming from a load test. */
  is_load_test?: boolean;
  /** Indicates whether the incoming request is an internal search comparison. */
  is_search_comparison?: boolean;
  /** Session Id of the session. */
  session_id?: string;
}

/**
 * Activity receiving a null offset interprets it the same as offset 0.
 * Activity sending a null offset represents that it does not have more items to paginate through.
 */
export interface SearchOffset {
  offsets?: Uint8Array[];
}
